var map = {
	"./BaseButton.vue": "3f79",
	"./Checkbox.vue": "1961",
	"./LoadingIndicator.vue": "cd7a",
	"./Logo.vue": "0c57",
	"./PageHeader.vue": "8381",
	"./ResizedImage.vue": "5540",
	"./SelectField.vue": "b63f",
	"./TextArea.vue": "3471",
	"./TextField.vue": "6e20",
	"./Toolbar.vue": "6e3b",
	"./icons/IconArchive.vue": "34cb",
	"./icons/IconArrowDownSmall.vue": "1023",
	"./icons/IconArrowRight.vue": "db08",
	"./icons/IconAuth0.vue": "84c5",
	"./icons/IconBook.vue": "d3fe",
	"./icons/IconBoretti.vue": "e366",
	"./icons/IconBorettis.vue": "0e6f",
	"./icons/IconBorettisMint.vue": "20a4",
	"./icons/IconBorettisPesto.vue": "b666",
	"./icons/IconBorettisRose.vue": "4157",
	"./icons/IconBorettisWine.vue": "d530",
	"./icons/IconCamera.vue": "4412",
	"./icons/IconCheckbox.vue": "a8a8",
	"./icons/IconCheckmark.vue": "205d",
	"./icons/IconChevronDown.vue": "4261",
	"./icons/IconChevronLeft.vue": "9562",
	"./icons/IconChevronUp.vue": "4c49",
	"./icons/IconClock.vue": "4643",
	"./icons/IconClose.vue": "130d",
	"./icons/IconCommunity.vue": "310b",
	"./icons/IconCostprice.vue": "dbaa",
	"./icons/IconCreateNew.vue": "a0c0",
	"./icons/IconCrown.vue": "5a9b",
	"./icons/IconCutlery.vue": "5a86",
	"./icons/IconDiamond.vue": "c55a",
	"./icons/IconDisband.vue": "776d",
	"./icons/IconDots.vue": "a4e8",
	"./icons/IconDownload.vue": "3a5b",
	"./icons/IconEdit.vue": "aafc",
	"./icons/IconExternal.vue": "17ec",
	"./icons/IconFile.vue": "6c9c",
	"./icons/IconFileDoc.vue": "729f",
	"./icons/IconFileFont.vue": "4245",
	"./icons/IconFileIllustrator.vue": "0dab",
	"./icons/IconFileImagetiff.vue": "89a0",
	"./icons/IconFileIndesign.vue": "3db1",
	"./icons/IconFilePdf.vue": "6551",
	"./icons/IconFilePhotoshop.vue": "1c77",
	"./icons/IconFilePresentation.vue": "f010",
	"./icons/IconFileSelected.vue": "6bc5",
	"./icons/IconFileSpreadsheet.vue": "185d",
	"./icons/IconFileThreeDimensional.vue": "631c",
	"./icons/IconFileVideo.vue": "b726",
	"./icons/IconFileZip.vue": "28cc",
	"./icons/IconFilter.vue": "6fff",
	"./icons/IconFolder.vue": "3d08",
	"./icons/IconHanos.vue": "6d6d",
	"./icons/IconHoreko.vue": "0f87",
	"./icons/IconHubper.vue": "03f4",
	"./icons/IconInfo.vue": "81a5",
	"./icons/IconLightBulb.vue": "ce7d",
	"./icons/IconLink.vue": "8bde",
	"./icons/IconLockClosed.vue": "b468",
	"./icons/IconLoss.vue": "9986",
	"./icons/IconMinus.vue": "5c74",
	"./icons/IconOnboarding.vue": "425b",
	"./icons/IconPackage.vue": "538c",
	"./icons/IconPackageDots.vue": "da71",
	"./icons/IconPackageEmpty.vue": "0e71",
	"./icons/IconPackageNew.vue": "2eed",
	"./icons/IconPlay.vue": "192e",
	"./icons/IconPlus.vue": "cbe2",
	"./icons/IconPos.vue": "6456",
	"./icons/IconPower.vue": "e00c",
	"./icons/IconProfit.vue": "de6b",
	"./icons/IconPropose.vue": "d775",
	"./icons/IconRecruitee.vue": "7e19",
	"./icons/IconReset.vue": "91cc",
	"./icons/IconSalesprice.vue": "9e93",
	"./icons/IconSend.vue": "af77",
	"./icons/IconShoppingCart.vue": "3e33",
	"./icons/IconSortArrow.vue": "4fb4",
	"./icons/IconStar.vue": "8acb",
	"./icons/IconStats.vue": "e8e0",
	"./icons/IconStove.vue": "268d",
	"./icons/IconThumbsDownFill.vue": "5266",
	"./icons/IconThumbsDownOutline.vue": "bdad",
	"./icons/IconThumbsUpFill.vue": "74e0",
	"./icons/IconThumbsUpOutline.vue": "27aa",
	"./icons/IconTick.vue": "af1c",
	"./icons/IconTrash.vue": "5a79",
	"./icons/IconUpload.vue": "2098",
	"./icons/IconUploadFail.vue": "c706",
	"./icons/IconUploadSuccess.vue": "2382",
	"./icons/IconUser.vue": "039c",
	"./icons/IconUserGroup.vue": "abbe",
	"./icons/IconVideoCamera.vue": "f714"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15f2";